import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldAlert, MailX, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function AdminCompliancePage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-846">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-847">
        <div className="flex items-center gap-4" data-id="element-848">
          <span className="text-xl font-bold text-red-500" data-id="element-849">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-850"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-851">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-852">
              Dashboard
            </Link>
            <Link to="/admin/compliance" className="text-textMain" data-id="element-853">
              Compliance
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-854">
        <div className="mb-8" data-id="element-855">
          <h1 className="text-2xl font-bold mb-1" data-id="element-856">
            Compliance & Deliverability
          </h1>
          <p className="text-sm text-textMuted" data-id="element-857">
            Manage suppression lists, spam complaints, and sending limits.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-858">
          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-859">
            <div className="flex items-center gap-3 mb-4" data-id="element-860">
              <div className="w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center text-red-500" data-id="element-861">
                <MailX className="w-5 h-5" data-id="element-862" />
              </div>
              <div data-id="element-863">
                <h3 className="font-bold" data-id="element-864">Global Suppression</h3>
                <p className="text-xs text-textMuted" data-id="element-865">
                  Hard bounces & unsubscribes
                </p>
              </div>
            </div>
            <div className="text-3xl font-bold mb-4" data-id="element-866">1,248</div>
            <button className="w-full py-2 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-867">
              Manage List
            </button>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-868">
            <div className="flex items-center gap-3 mb-4" data-id="element-869">
              <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center text-amber-500" data-id="element-870">
                <AlertTriangle className="w-5 h-5" data-id="element-871" />
              </div>
              <div data-id="element-872">
                <h3 className="font-bold" data-id="element-873">Spam Complaints</h3>
                <p className="text-xs text-textMuted" data-id="element-874">Last 30 days</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-amber-500 mb-4" data-id="element-875">12</div>
            <button className="w-full py-2 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-876">
              Review Complaints
            </button>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-877">
            <div className="flex items-center gap-3 mb-4" data-id="element-878">
              <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center text-green-500" data-id="element-879">
                <CheckCircle2 className="w-5 h-5" data-id="element-880" />
              </div>
              <div data-id="element-881">
                <h3 className="font-bold" data-id="element-882">Domain Health</h3>
                <p className="text-xs text-textMuted" data-id="element-883">
                  Sender reputation score
                </p>
              </div>
            </div>
            <div className="text-3xl font-bold text-green-500 mb-4" data-id="element-884">98/100</div>
            <button className="w-full py-2 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-885">
              View Metrics
            </button>
          </div>
        </div>

        <div className="bg-surface border border-border rounded-xl p-6" data-id="element-886">
          <h3 className="font-semibold mb-4 flex items-center gap-2" data-id="element-887">
            <ShieldAlert className="w-5 h-5 text-red-500" data-id="element-888" /> Active Workspace
            Flags
          </h3>
          <div className="space-y-4" data-id="element-889">
            <div className="p-4 bg-background border border-border rounded-lg flex items-center justify-between" data-id="element-890">
              <div data-id="element-891">
                <h4 className="font-bold text-red-500 mb-1" data-id="element-892">
                  Neon Dreams (Workspace ID: #4421)
                </h4>
                <p className="text-sm text-textMuted" data-id="element-893">
                  Sending paused. Exceeded 15% bounce rate threshold on recent
                  campaign.
                </p>
              </div>
              <button className="px-4 py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-894">
                Review Workspace
              </button>
            </div>
            <div className="p-4 bg-background border border-border rounded-lg flex items-center justify-between" data-id="element-895">
              <div data-id="element-896">
                <h4 className="font-bold text-amber-500 mb-1" data-id="element-897">
                  The Bluegrass Boys (Workspace ID: #1029)
                </h4>
                <p className="text-sm text-textMuted" data-id="element-898">
                  Warning: 3 spam complaints received in the last 48 hours.
                </p>
              </div>
              <button className="px-4 py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-899">
                Review Workspace
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}